import classNames from 'classnames'
import React from 'react'

import { Notification, NotificationProps } from '../notification/notification.js'

export interface NotificationListProps {
    items: NotificationProps[]
    className?: string
}

export const NotificationList = (props: NotificationListProps): JSX.Element => {
    const className: string = classNames('notification-list', props.className)

    const topItems = props.items.filter((i) => i.type === 'info')
    const bottomItems = props.items.filter((i) => i.type !== 'info')

    const renderTopItems = () => (
        <div className="notification-list__top">
            {topItems.map((item: NotificationProps, index: number) => {
                return (
                    <div className="notification-list__item" key={index}>
                        <Notification {...item} />
                    </div>
                )
            })}
        </div>
    )

    const renderBottomItems = () => (
        <div className="notification-list__bottom">
            {bottomItems.map((item: NotificationProps, index: number) => {
                return (
                    <div className="notification-list__item" key={index}>
                        <Notification {...item} />
                    </div>
                )
            })}
        </div>
    )

    return (
        <div className={className}>
            {renderTopItems()}
            {renderBottomItems()}
        </div>
    )
}
